export const brandAnalysis = {
  "tab_name": "brand-analysis",
  "data": [
    {
      "name": "University of Brighton",
      "series": [
        {
          "name": "Website Content",
          "value": 76.25
        },
        {
          "name": "Social Media",
          "value": 75
        },
        {
          "name": "Digital Media",
          "value": 72.5
        },
        {
          "name": "YouTube Content",
          "value": 75
        },
        {
          "name": "Thought Leadership",
          "value": 50.0
        },
        {
          "name": "Overall AI Visibility",
          "value": 69.75
        }
      ]
    },
    {
      "name": "University of Central Lancashire",
      "series": [
        {
          "name": "Website Content",
          "value": 52.5
        },
        {
          "name": "Social Media",
          "value": 70
        },
        {
          "name": "Digital Media",
          "value": 62.5
        },
        {
          "name": "YouTube Content",
          "value": 65
        },
        {
          "name": "Thought Leadership",
          "value": 75.0
        },
        {
          "name": "Overall AI Visibility",
          "value": 66.66666666666667
        }
      ]
    },
    {
      "name": "University of Hull",
      "series": [
        {
          "name": "Website Content",
          "value": 85.0
        },
        {
          "name": "Social Media",
          "value": 80
        },
        {
          "name": "Digital Media",
          "value": 77.5
        },
        {
          "name": "YouTube Content",
          "value": 82
        },
        {
          "name": "Thought Leadership",
          "value": 88.0
        },
        {
          "name": "Overall AI Visibility",
          "value": 82.5
        }
      ]
    },
    {
      "name": "University of Salford",
      "series": [
        {
          "name": "Website Content",
          "value": 78.75
        },
        {
          "name": "Social Media",
          "value": 75
        },
        {
          "name": "Digital Media",
          "value": 72.5
        },
        {
          "name": "YouTube Content",
          "value": 78
        },
        {
          "name": "Thought Leadership",
          "value": 82.0
        },
        {
          "name": "Overall AI Visibility",
          "value": 77.25
        }
      ]
    },
    {
      "name": "University of West London",
      "series": [
        {
          "name": "Website Content",
          "value": 65.0
        },
        {
          "name": "Social Media",
          "value": 70
        },
        {
          "name": "Digital Media",
          "value": 67.5
        },
        {
          "name": "YouTube Content",
          "value": 68
        },
        {
          "name": "Thought Leadership",
          "value": 70.0
        },
        {
          "name": "Overall AI Visibility",
          "value": 68.1
        }
      ]
    }
  ],
  "evidence_sources": [
    {
      "category": "domain_discovery",
      "source": "University Website",
      "url": "https://www.brighton.ac.uk",
      "confidence_score": 0.9
    },
    {
      "category": "website_content",
      "source": "Enhanced Homepage Analysis",
      "url": "https://www.brighton.ac.uk",
      "confidence_score": 0.9
    },
    {
      "category": "tuition_fees",
      "source": "Fee Page Analysis",
      "url": "https://www.brighton.ac.uk/international/fees",
      "confidence_score": 0.8
    },
    {
      "category": "domain_discovery",
      "source": "University Website",
      "url": "https://www.centrallancashire.ac.uk",
      "confidence_score": 0.9
    },
    {
      "category": "social_media_analysis",
      "source": "Social Media Platforms",
      "url": "https://twitter.com/uclan",
      "confidence_score": 0.85
    },
    {
      "category": "youtube_analysis",
      "source": "YouTube Channel Analysis",
      "url": "https://youtube.com/@uclan",
      "confidence_score": 0.8
    }
  ],
  "recommendations": [
    {
      "category": "Thought Leadership Content",
      "issue": "Low thought leadership content performance",
      "recommendation": "Improve thought leadership content quality and frequency",
      "priority": "High",
      "priority_score": 3,
      "expected_impact": "Significant improvement in content engagement",
      "current_score": 50.0,
      "target_score": 80
    },
    {
      "category": "Website Content",
      "issue": "Moderate website content performance",
      "recommendation": "Optimize homepage for conversions with clear CTAs",
      "priority": "Medium",
      "priority_score": 2,
      "expected_impact": "Moderate improvement in content reach",
      "current_score": 76.25,
      "target_score": 90
    },
    {
      "category": "Youtube Content",
      "issue": "Moderate youtube content performance",
      "recommendation": "Optimize youtube content for better engagement",
      "priority": "Medium",
      "priority_score": 2,
      "expected_impact": "Moderate improvement in content reach",
      "current_score": 75,
      "target_score": 90
    },
    {
      "category": "Website Content",
      "issue": "Low website content performance",
      "recommendation": "Increase blog content frequency and SEO optimization",
      "priority": "High",
      "priority_score": 3,
      "expected_impact": "Significant improvement in content engagement",
      "current_score": 52.5,
      "target_score": 80
    },
    {
      "category": "Social Media Content",
      "issue": "Moderate social media content performance",
      "recommendation": "Optimize social media content for better engagement",
      "priority": "Medium",
      "priority_score": 2,
      "expected_impact": "Moderate improvement in content reach",
      "current_score": 70,
      "target_score": 90
    },
    {
      "category": "Digital Media Content",
      "issue": "Moderate digital media content performance",
      "recommendation": "Optimize digital media content for better engagement",
      "priority": "Medium",
      "priority_score": 2,
      "expected_impact": "Moderate improvement in content reach",
      "current_score": 62.5,
      "target_score": 90
    }
  ],
  "cached": false,
  "timestamp": "2025-08-19T18:34:40.325339",
  "models_used": [
    "chatgpt"
  ],
  "plan_type": "university_paid"
};
